import { IsNotEmpty, IsByteLength, NotEquals } from 'class-validator';
import { FormDataBase } from '@/common/form';

export class RegistrationDetailsFormDataCloudAccount extends FormDataBase {
    @IsNotEmpty({ message: 'Account Number is required' })
    @NotEquals('000000', { message: 'Account Number is invalid' })
    accountId: string = '';

    authorisedPurchaserEmail: string = '';

    @IsByteLength(1, 10, { message: 'Billing Account Number is not valid' })
    @NotEquals('999999999', { message: 'Billing Account Number is not valid' })
    @NotEquals('9999999999', { message: 'Billing Account Number is not valid' })
    @IsNotEmpty({ message: 'Billing Account Number is required' })
    ban: string = '';

    @IsNotEmpty({ message: 'Account Name is required' })
    companyName: string = '';

    registrationId: string = '';

    @IsByteLength(1, 10, { message: 'Customer Identification Number is not valid' })
    @NotEquals('0000000000', { message: 'Customer Identification Number is not valid' })
    @IsNotEmpty({ message: 'Customer Identification Number is required' })
    cidn: string = '';
}
